<div [class]="notificationmessageClasses()">
	<div class="a-notification-message__header">
		<a-icon
			class="a-notification-message__icon"
			[name]="icon()"
			[size]="21.8"
			[units]="'px'"
			[inheritColors]="true"
		></a-icon>
		<div class="a-notification-message__title">{{ title() }}</div>
		@if (closable()) {
			<a-icon
				class="a-notification-message__close-button"
				[name]="'close'"
				[size]="14"
				[units]="'px'"
				[colors]="['gray-60']"
				(click)="closeNotification()"
			></a-icon>
		}
	</div>
	<div class="a-notification-message__body">
		{{ message() }}
	</div>
</div>
